import React from "react";
import PropTypes from "prop-types";
import { Navbar, Button } from "reactstrap";

const NavbarTop = ({ toggleSidebar }) => {
  const handleToggle = () => {
    toggleSidebar();
  };

  return (
    <Navbar className="navbar-top navbar-expand-lg navbar-light bg-white border-bottom">
      <div className="d-flex align-items-center">
        <Button
          color="link"
          className="navbar-toggler-humburger-icon"
          onClick={handleToggle}
          style={{
            border: "none",
            background: "none",
            padding: "0.5rem",
            marginLeft: "0.5rem",
          }}
        >
          <span
            style={{
              fontSize: "1.25rem",
              color: "#6c757d",
              fontWeight: "bold",
            }}
          >
            ☰
          </span>
        </Button>
      </div>
    </Navbar>
  );
};

NavbarTop.propTypes = {
  toggleSidebar: PropTypes.func,
};

NavbarTop.defaultProps = {
  toggleSidebar: () => {},
};

export default NavbarTop;
